import "./wizard.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

export default function CannotStartCheckout(): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "AiGuideSignupCheckoutStartErrored",
            eventSchemaVersion: 1,
        });
    });

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="sad-path-heading">
                    {t`A checkout session could not be started.`}
                </h1>
                <p>
                    {t`This could be caused by a temporary problem. Try again in a few minutes.`}
                </p>
            </div>
        </div>
    );
}
